var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModalClose = function SvgModalClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "#F7F5EE",
    stroke: "#E7E6E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9788 13.875C11.3734 13.2537 11.3734 12.2463 11.9788 11.625C12.5843 11.0037 13.5659 11.0037 14.1713 11.625L24.4029 22.125C25.0083 22.7463 25.0083 23.7537 24.4029 24.375C23.7974 24.9963 22.8158 24.9963 22.2104 24.375L11.9788 13.875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0202 13.875C24.6256 13.2537 24.6256 12.2463 24.0202 11.625C23.4148 11.0037 22.4332 11.0037 21.8277 11.625L11.5961 22.125C10.9907 22.7463 10.9907 23.7537 11.5961 24.375C12.2016 24.9963 13.1832 24.9963 13.7886 24.375L24.0202 13.875Z",
    fill: "black"
  })));
};
export default SvgModalClose;